import React from 'react';
import { CollectionStateProvider } from 'Context/CollectionStateContext';
import { useAuthenticationFactorListContext } from '../AuthenticationFactorListContext';
import Container from './Container';

const AuthFactorModal = () => {
  const { modalLink } = useAuthenticationFactorListContext();

  // Don't render anything if there should be no open modal
  if (!modalLink) {
    return null;
  }

  return (
    <CollectionStateProvider
      args={{
        link: modalLink,
      }}
    >
      <Container />
    </CollectionStateProvider>
  );
};

export default AuthFactorModal;
